/**
 * Nested child modal stack over Accounts Client Details (Resolve Support Case,
 * Change owner email, etc.). Scoped classes only — do not change global Bootstrap.
 *
 * Bootstrap defaults: .modal-backdrop z-index 1050, .modal z-index 1055.
 * A second modal's backdrop is still 1050, so it paints UNDER the parent .modal
 * (1055). That leaves Client Details fully bright behind the child.
 *
 * Required visual order:
 *   page < parent (Client Details) < child backdrop < child dialog
 *
 * Opacity must stay in sync with accounts.module.scss
 * `.resolveSupportBackdrop` (--bs-backdrop-opacity / opacity).
 */
export const NESTED_RESOLVE_STACK = {
  /** Above parent .modal (1055); below child dialog. */
  childBackdropZIndex: 1065,
  /** Above child backdrop. */
  childModalZIndex: 1075,
  /** Black translucent dim of Client Details (owner QA ~50–60%). */
  childBackdropOpacity: 0.55,
} as const;
